import PropTypes from 'prop-types';
import React from 'react';
import CSPStore from './csp_store';
import CSPMiniGrid from './csp_mini_grid';
import Pagination from '../../shared/pagination';

export default class CSPMiniGridContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: CSPStore.pagesWithImages(true),
    };

    this.setPages = this.setPages.bind(this);
  }

  componentDidMount() {
    CSPStore.listen(this.setPages);
  }

  componentWillUnmount() {
    CSPStore.unlisten(this.setPages);
  }

  setPages() {
    this.setState({
      pages: CSPStore.pagesWithImages(true),
      totalPages: CSPStore.state.response.total_pages,
      currentPage: CSPStore.state.response.current_page,
    });
  }

  render() {
    return (
      <div>
        <CSPMiniGrid
          pages={this.state.pages}
          heading={this.props.heading}
          stripBrandFromTitle={this.props.stripBrandFromTitle}
        />
        <Pagination
          changePage={this.props.changePageCb}
          totalPages={this.state.totalPages}
          currentPage={this.state.currentPage}
          noFollow
        />
      </div>
    );
  }
}

CSPMiniGridContainer.propTypes = {
  heading: PropTypes.string.isRequired,
  stripBrandFromTitle: PropTypes.bool,
  changePageCb: PropTypes.func,
};
